import React from 'react';
import { Box } from '@drone-js/core';
import styled from 'styled-components';

const StickyFooterStyled = styled(Box)`
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
`;

interface StickyFooterProps {
    elementName: string;
    ariaHidden?: boolean;
    zIndex?: number;
    position?: 'absolute' | 'sticky';
}

export const StickyFooter: React.FC<React.PropsWithChildren<StickyFooterProps>> = (props) => {
    return (
        <StickyFooterStyled
            data-testid={props.elementName}
            display="flex"
            justifyContent="center"
            py="12"
            px="12"
            position={props.position ?? 'sticky'}
            bottom="0"
            width="100%"
            boxShadow="bottom-l"
            backgroundColor="base.surface"
            zIndex={props.zIndex ?? 20}
            aria-hidden={props.ariaHidden}
        >
            {props.children}
        </StickyFooterStyled>
    );
};
StickyFooter.displayName = 'StickyFooter';
